export const STATUS = [
    {
        label: 'Đang hoạt động',
        value: 'true'
    },
    {
        label: 'Tạm ngưng hoạt động',
        value: 'false'
    },
]